var dynamicSvgConfig = {
  xml: '',
  theme: 'light',
  width: 24,
  height: 24
};
export default {
  light: dynamicSvgConfig,
  dark: dynamicSvgConfig,
  white: dynamicSvgConfig
};